export default __webpack_public_path__ + "static/media/everybill-logo-ko.bdfea23e.svg";